import React, { useEffect, useState} from 'react';
import classes from './RegisterContent.module.scss';
import registerImage from '../../media/images/registerImage.png';
import logo from '../../media/logo/logoSecondary.png';
import useInput from "../../hooks/use-inputs";
import useAuth from "../../hooks/use-Auth";
import { useSnackbar } from 'notistack'
import { useNavigate, useLocation } from 'react-router-dom';
import { sendEmailVerificationOtp, verifyEmailVerificationOtp, sendPhoneOtp, verifyPhoneOtp, checkDuplicates } from '../../services';
import { FEATURES } from '../../config/constants';
import OtpVerification from './OtpVerification';
import PhoneInput, {
	isValidPhoneNumber
} from 'react-phone-number-input'
import 'react-phone-number-input/style.css';




const RegisterContent = () => {
  const { sendRegisterRequest } = useAuth();
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [receiveTextMessages, setReceiveTextMessages] = useState(false);
  const [affiliateCode, setAffiliateCode] = useState('');

  const [steps, setSteps] = useState(1);
  const [emailOtp, setEmailOtp] = useState('');
  // Proof of email ownership issued by POST /auth/email-otp/verify. Lives in component
  // state only — it is never written to localStorage/sessionStorage.
  const [emailVerificationToken, setEmailVerificationToken] = useState('');
  const [phoneOtp, setPhoneOtp] = useState('');
  const [resendTimer, setResendTimer] = useState(0);
  const [isFirstPhoneAttempt, setIsFirstPhoneAttempt] = useState(true);
  const [phoneNumber,setPhoneNumber] = useState('');

  // Get affiliate code from URL parameters
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get('ref');
    if (code) {
      setAffiliateCode(code);
    }
  }, [location]);

  useEffect(() => {
    let interval;
    if (resendTimer > 0) {
      interval = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [resendTimer]);

    const {
        value: enteredEmail,
        valueIsValid: enterEmailIsValid,
        hasError: emailInputIsInvalid,
        inputChangeHandler: emailInputChangeHandler,
        inputBlurHandler: emailInputBlurHandler,
        reset: resetEmail,
      } = useInput((value) => value.trim() !== "" && value.includes("@"));


    const {
        value: enteredFirstName,
        valueIsValid: enterFirstNameIsValid,
        hasError: firstNameInputIsInvalid,
        inputChangeHandler: firstNameInputChangeHandler,
        inputBlurHandler: firstNameInputBlurHandler,
        reset: resetFirstName,
      } = useInput((value) => value.trim() !== "");

      const {
        value: enteredLastName,
        valueIsValid: enterLastNameIsValid,
        hasError: lastNameInputIsInvalid,
        inputChangeHandler: lastNameInputChangeHandler,
        inputBlurHandler: lastNameInputBlurHandler,
        reset: resetLastName,
      } = useInput((value) => value.trim() !== "");

      const {
        valueIsValid: enteredPhoneNumberIsValid,
        reset: resetPhoneNumber,
      } = useInput((value) => {
        // Basic phone number validation - at least 10 digits
        const phoneRegex = /^\d{10,15}$/;
        return value.trim() !== "" && phoneRegex.test(value.replace(/[^0-9]/g, ''));
      });

      const {
        value: enteredPassword,
        valueIsValid: enteredPasswordIsValid,
        hasError: passwordInputIsInvalid,
        inputChangeHandler: passwordInputChangeHandler,
        inputBlurHandler: passwordInputBlurHandler,
        reset: resetPassword,
      } = useInput((value) => {
        const hasMinLength = value.length >= 8;
        const hasUpperCase = /[A-Z]/.test(value);
        const hasLowerCase = /[a-z]/.test(value);
        const hasNumbers = /[0-9]/.test(value);
        const hasSpecialChar = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(value);
      
        return value.trim() !== "" && 
               hasMinLength && 
               hasUpperCase && 
               hasLowerCase && 
               hasNumbers && 
               hasSpecialChar;
      });

      const {
        value: enteredConfirmPassword,
        valueIsValid: enteredConfirmPasswordIsValid,
        hasError: confirmPasswordInputIsInvalid,
        inputChangeHandler: confirmPasswordInputChangeHandler,
        inputBlurHandler: confirmPasswordInputBlurHandler,
        reset: resetConfirmPassword,
      } = useInput((value) => value.trim() !== "" && value === enteredPassword);

 //Form Validation
  let submitFormValid = false;
  if (enterEmailIsValid && enteredPasswordIsValid && enterFirstNameIsValid && enterLastNameIsValid && enteredConfirmPasswordIsValid && phoneNumber && isValidPhoneNumber(phoneNumber)) {
    submitFormValid = true;
  }

const submitHandler = async (event) => {
  if (event) {
    event.preventDefault();
  }

  if (!submitFormValid) {
    setSteps(1);
    return;
  }
  
  setLoading(true);

  try {
    const verifyResponse = await verifyPhoneOtp({phoneNumber:phoneNumber,otp:phoneOtp});
    if(verifyResponse.message === "OTP Verified Successfully!"){
      const response = await sendRegisterRequest({
        email: enteredEmail.toLowerCase(),
        password: enteredPassword,
        firstName: enteredFirstName,
        lastName: enteredLastName,
        confirmPassword: enteredConfirmPassword,
        phone: phoneNumber.replace(/[^0-9]/g, ''),
        receiveTextMessages: receiveTextMessages,
        affiliateCode: affiliateCode,
        emailVerificationToken: emailVerificationToken
      });

      if (response?.status === 201) {
        displaySnackbar("Account created successfully! You're starting with free tier access. Upgrade to VIP for enhanced features.", "success");
        navigate('/login');
        resetForm();
      } else if (response?.code === 400 || response?.status === 400) {
        handleRegistrationFailure(response);
      } else {
        // Covers 409 duplicates and the 429 from the auth limiter (which answers
        // with a plain string body).
        displaySnackbar(responseMessage(response) || "Registration failed. Please try again.", "error");
      }
    } else {
      displaySnackbar("Invalid Phone OTP", "error");
      setIsFirstPhoneAttempt(false);
    }
  } catch (error) {
    console.error("An error occurred while submitting the form:", error);
    displaySnackbar("Registration failed", "error");
  } finally {
    setLoading(false);
  }
};

  const displaySnackbar = (message, variant) => {
    enqueueSnackbar(message, {
      variant,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right",
      },
    });
  };

  // Rate limited responses from the per-IP limiters come back as a plain string body,
  // everything else as { message, ... }. Normalise both to a string.
  const responseMessage = (response) => {
    return typeof response === "string" ? response : response?.message;
  };
  
  // A 400 from signup can mean the proof-of-email token expired (it lives 15 minutes).
  // Drop it so the user is asked to verify the address again rather than replaying a
  // token the server has already rejected.
  const handleRegistrationFailure = (response) => {
    const message = response?.message || "Registration failed";
    if (message.startsWith("Email verification is invalid")
      || message.includes("\"emailVerificationToken\"")) {
      setEmailVerificationToken('');
      setEmailOtp('');
    }
    setSteps(1);
    displaySnackbar(message, "error");
  };

  const resetForm = () => {
    resetEmail();
    resetFirstName();
    resetLastName();
    resetPassword();
    resetConfirmPassword();
    resetPhoneNumber();
    setReceiveTextMessages(false);
    setEmailOtp('');
    setEmailVerificationToken('');
  };

const sendEmailOtpHandler = async () => {
  console.log("sendEmailOtpHandler called");
  if(!submitFormValid){
    console.log("Form is not valid. Validation status:", {
      emailValid: enterEmailIsValid,
      passwordValid: enteredPasswordIsValid,
      firstNameValid: enterFirstNameIsValid,
      lastNameValid: enterLastNameIsValid,
      confirmPasswordValid: enteredConfirmPasswordIsValid,
      phoneNumberValid: enteredPhoneNumberIsValid
    });
    return;
  }
  if(resendTimer > 0){
    console.log("Resend timer is still active:", resendTimer);
    return;
  }

  // Check for duplicates before sending OTP
  setLoading(true);
  try {
    console.log("Checking for duplicates with:", {
      email: enteredEmail.toLowerCase(),
      phone: phoneNumber.replace(/[^0-9]/g, '')
    });
    
    const duplicateCheck = await checkDuplicates({
      email: enteredEmail.toLowerCase(),
      phone: phoneNumber.replace(/[^0-9]/g, '')
    });

    console.log("Duplicate check response:", duplicateCheck);
    
    // Check if duplicates were found
    if (duplicateCheck?.available === false) {
      const errorMessage = duplicateCheck?.message || "Email or phone number already exists!";
      console.log("Duplicate found in success response, blocking OTP:", errorMessage);
      displaySnackbar(errorMessage, "error");
      setLoading(false);
      return;
    }
    
    // If we reach here, no duplicates found, proceed with OTP.
    // The code is generated and stored by the server; the browser never sees it.
    let email = enteredEmail.toLowerCase();

    const otpRes = await sendEmailVerificationOtp({email});
    const otpResMessage = responseMessage(otpRes);
    if (otpResMessage === "Otp has been sent to your email") {
      console.log("OTP sent")
      // A fresh code invalidates any proof we were already holding.
      setEmailVerificationToken('');
      setEmailOtp('');
      displaySnackbar("OTP Sent to Email", "success");
      setResendTimer(60);
      setSteps(2);
    } else {
      // Covers the 400 validation message and both 429 shapes (per-address cooldown
      // and the per-IP limiter, which answers with a plain string body).
      console.log("OTP not sent")
      displaySnackbar(otpResMessage || "Failed to send OTP", "error");
    }
  } catch (error) {
    console.error("Error in sendEmailOtpHandler:", error);
    console.log("Error details:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message
    });
    
    if (error.response?.status === 409) {
      // Handle duplicate error - STOP execution here
      const errorMessage = error.response?.data?.message || "Email or phone number already exists!";
      console.log("Duplicate found, blocking OTP:", errorMessage);
      displaySnackbar(errorMessage, "error");
      return; // Explicitly return to prevent any further execution
    } else {
      // Prefer the server's own message. A 502 from the mail transport says the code
      // could not be sent and to try again — which is actionable, and which the
      // generic fallback below throws away.
      displaySnackbar(error.response?.data?.message || "Failed to send OTP", "error");
    }
  } finally {
    setLoading(false);
  }
}

  const sendPhoneOtpHandler = async () => {
    if(!submitFormValid){
      return;
    }

    // The code is checked by the server, which answers with a short lived token
    // proving the address belongs to this user. A token we already hold is reused so
    // returning to this step does not consume a second (single use) verification.
    let verificationToken = emailVerificationToken;
    if (!verificationToken) {
      // The server destroys the otp after 5 wrong tries, so do not spend an attempt on
      // a half typed code.
      if (!/^\d{6}$/.test(emailOtp)) {
        displaySnackbar("Enter the 6 digit code from your email", "error");
        return;
      }
      setLoading(true);
      try {
        const verifyRes = await verifyEmailVerificationOtp({
          email: enteredEmail.toLowerCase(),
          otp: emailOtp
        });
        verificationToken = verifyRes?.data?.emailVerificationToken;
        if (!verificationToken) {
          displaySnackbar(responseMessage(verifyRes) || "Invalid OTP", "error");
          return;
        }
        setEmailVerificationToken(verificationToken);
        displaySnackbar("Email verified", "success");
      } catch (error) {
        console.error("Error verifying email OTP:", error);
        displaySnackbar("Invalid OTP", "error");
        return;
      } finally {
        setLoading(false);
      }
    }

    if (!FEATURES.PHONE_OTP_ENABLED) {
      // If phone OTP is disabled, proceed directly with registration
      try {
        const response = await sendRegisterRequest({
          email: enteredEmail.toLowerCase(),
          password: enteredPassword,
          firstName: enteredFirstName,
          lastName: enteredLastName,
          confirmPassword: enteredConfirmPassword,
          phone: phoneNumber.replace(/[^0-9]/g, ''),
          receiveTextMessages: receiveTextMessages,
          affiliateCode: affiliateCode,
          emailVerificationToken: verificationToken
        });

        if (response?.status === 201) {
          displaySnackbar("Account created successfully! You're starting with free tier access. Upgrade to VIP for enhanced features.", "success");
          navigate('/login');
          resetForm();
        } else if (response?.code === 400 || response?.status === 400) {
          handleRegistrationFailure(response);
        } else {
          // Covers 409 duplicates and the 429 from the auth limiter (which answers
          // with a plain string body).
          displaySnackbar(responseMessage(response) || "Registration failed. Please try again.", "error");
        }
      } catch (error) {
        console.error("Registration failed:", error);
        displaySnackbar("Registration failed", "error");
      }
      return;
    }

    sendPhoneOtp({phoneNumber}).then((res) => {
      if (res?.message === "OTP sent successfully!") {
        console.log("OTP sent")
        displaySnackbar("OTP Sent to phone", "success");
      } else {
        console.log("OTP not sent")
      }
    })
    setResendTimer(60);
    setSteps(3);
  }

  const handleEmailOtpChange = async (otpValue) => {
    setEmailOtp(otpValue);
    // No auto-submit here on purpose: the server destroys the otp after 5 wrong
    // attempts, so verification is only triggered when the user presses Verify.
  };


  const handlePhoneOtpChange = async (otpValue) => {
    setPhoneOtp(otpValue);
    if (isFirstPhoneAttempt && otpValue.length === 7) {
      setLoading(true);
      try {
      const verifyResponse = await verifyPhoneOtp({phoneNumber:phoneNumber,otp:otpValue});
      if(verifyResponse.message === "OTP Verified Successfully!"){
          const response = await sendRegisterRequest({
            email: enteredEmail.toLowerCase(),
            password: enteredPassword,
            firstName: enteredFirstName,
            lastName: enteredLastName,
            confirmPassword: enteredConfirmPassword,
            phone: phoneNumber.replace(/[^0-9]/g, ''),
            receiveTextMessages: receiveTextMessages,
            affiliateCode: affiliateCode,
            emailVerificationToken: emailVerificationToken
          });
          if (response?.status === 201) {
            displaySnackbar("Account created successfully! You're starting with free tier access. Upgrade to VIP for enhanced features.", "success");
            navigate('/login');
            resetForm();
          } else if (response?.code === 400 || response?.status === 400) {
            handleRegistrationFailure(response);
          }
      } else {
      displaySnackbar("Invalid Phone OTP", "error");
      setIsFirstPhoneAttempt(false); // Disable auto-submit for subsequent attempts
      setLoading(false);
    }
  } catch (error) {
    displaySnackbar("Registration failed", "error");
  } finally {
    setLoading(false);
  }
    }
  }


  const firstNameInputClasses = firstNameInputIsInvalid ? `${classes.firstNameContainer} ${classes.invalid}` : `${classes.firstNameContainer}`;
  const lastNameInputClasses = lastNameInputIsInvalid ? `${classes.lastNameContainer} ${classes.invalid}` : `${classes.lastNameContainer}`;
  const emailInputClasses = emailInputIsInvalid ? `${classes.emailContainer} ${classes.invalid}` : `${classes.emailContainer}`;
  const phoneNumberInputIsInvalid = phoneNumber ? !isValidPhoneNumber(phoneNumber) : false;
  const phoneNumberInputClasses = phoneNumberInputIsInvalid ? `${classes.phoneNumberContainer} ${classes.invalid}` : `${classes.phoneNumberContainer}`;
  const passwordInputClasses = passwordInputIsInvalid
    ? `${classes.passwordContainer} ${classes.invalid}`
    : `${classes.passwordContainer}`;

const confirmPasswordInputClasses = confirmPasswordInputIsInvalid ? `${classes.confirmPasswordContainer} ${classes.invalid}` : `${classes.confirmPasswordContainer}`;
  const formInputClasses = !submitFormValid
    ? `${classes.submit} ${classes.formInvalid} purpleLightBtn`
    : `${classes.submit} purpleLightBtn`;


    return (
        <div className={classes.RegisterContainer}>
        <div className={classes.leftSideContainer}>
            <img src={registerImage} alt="register"/>
        </div>
        <div className={classes.rightSideContainer}>
        <div className={classes.formContainer}>
        <form onSubmit={submitHandler} className={classes.form}>
        <div className={classes.logo}>
            <img src={logo} alt="logo" />
        </div>
        {steps === 1 && (
          <> 
        <h1 className={classes.title}>Create an account</h1>
        <h3 className={classes.subtitle}>To continue, please create an account</h3>
        <div className={classes.box}>
            <div className={classes.nameContainer}>
                <div className={firstNameInputClasses}>
            <label htmlFor="firstName">First name</label>
            <input
              id="firstName"
              type="text"
              value={enteredFirstName}
              placeholder='Enter your first name'
              onChange={firstNameInputChangeHandler}
              onBlur={firstNameInputBlurHandler}
            />
            </div>
            <div className={lastNameInputClasses}>
            <label htmlFor="lastName">Last name</label>
            <input
              id="lastName"
              type="text"
              value={enteredLastName}
              placeholder='Enter your last name'
              onChange={lastNameInputChangeHandler}
              onBlur={lastNameInputBlurHandler}
            />
            </div>
            </div>
          <div className={emailInputClasses}>
            <label htmlFor="email">Email<sup>*</sup></label>
            <input
              id="email"
              type="email"
              value={enteredEmail}
              placeholder='Enter your email'
              onChange={emailInputChangeHandler}
              onBlur={emailInputBlurHandler}
            />
            {emailInputIsInvalid && <p>Enter Valid Email</p>}
          </div>
          <div className={phoneNumberInputClasses}>
            <label htmlFor="phoneNumber">Phone Number<sup>*</sup></label>
            {/* <input
              id="phoneNumber"
              type="tel"
              value={enteredPhoneNumber}
              placeholder='Enter your phone number'
              onChange={phoneNumberInputChangeHandler}
              onBlur={phoneNumberInputBlurHandler}
            /> */}

            <PhoneInput
              international
              defaultCountry="US"
              value={phoneNumber}
              onChange={setPhoneNumber}
              className={phoneNumberInputIsInvalid ? 'invalid' : ''}
              error={phoneNumber ? (isValidPhoneNumber(phoneNumber) ? undefined : 'Invalid phone number') : 'Phone number required'}/>
            {phoneNumber && !isValidPhoneNumber(phoneNumber) && <p>Enter Valid Phone Number</p>}
          </div>
          <div className={classes.checkboxContainer}>
            <input
              id="receiveTextMessages"
              type="checkbox"
              checked={receiveTextMessages}
              onChange={(e) => setReceiveTextMessages(e.target.checked)}
            />
            <label htmlFor="receiveTextMessages">I agree to receive text messages for updates and promotions</label>
          </div>
          <div className={passwordInputClasses}>
            <label htmlFor="password">Password<sup>*</sup></label>
            <input
              id="password"
              type="password"
              value={enteredPassword}
                placeholder='Enter your password'
              onChange={passwordInputChangeHandler}
              onBlur={passwordInputBlurHandler}
            />
            <p>Must be at least 8 Alpha Numeric characters & contains Special Character</p>
            {passwordInputIsInvalid && <p className={classes.errorMessage}>Enter Valid Password</p>}
          </div>
          <div className={confirmPasswordInputClasses}>
            <label htmlFor="confirmPassword">Confirm Password</label>
            <input
              id="password"
              type="password"
              value={enteredConfirmPassword}
              placeholder='Confirm your password'
              onChange={confirmPasswordInputChangeHandler}
              onBlur={confirmPasswordInputBlurHandler}
            />
            {confirmPasswordInputIsInvalid && <p>Password doesnot match</p>}
          </div>
          <div className={`${formInputClasses} ${classes.sendOtpBtn}`} onClick={sendEmailOtpHandler}>
          Get started
          </div>
          <div className={classes.existedAccount}>
                Already have an account?
                <a href="/login">Sign in</a>
            </div>
        </div>
        </>)}

        {steps === 2 && (
          <OtpVerification 
            otp={emailOtp}
            handleOtpChange={handleEmailOtpChange}
            submitHandler={sendPhoneOtpHandler}
            resendTimer={resendTimer}
            sendOtpHandler={sendEmailOtpHandler}
            loading={loading}
            submitFormValid={submitFormValid}
            formInputClasses={formInputClasses}
            title="Verify your email"
            type="email"
          />
        )}

      {steps === 3 && (
          <OtpVerification 
            otp={phoneOtp}
            handleOtpChange={handlePhoneOtpChange}
            submitHandler={submitHandler}
            resendTimer={resendTimer}
            sendOtpHandler={sendPhoneOtpHandler}
            loading={loading}
            submitFormValid={submitFormValid}
            formInputClasses={formInputClasses}
            title="Verify your phone number"
            type="phone"
          />
        )}


      </form>
            </div>
            {/* <div className={classes.bottomText}>
            © Copyright 2022 All Rights Reserved Magic Motorsports
            </div>  */}
        </div>
        </div>
    )
}

export default RegisterContent;